<mat-dialog-content>
  <p>Are you sure you want to reset the form?</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close class="cancel-button" [mat-dialog-close]="false">No</button>
  <button mat-button class="confirm-button" [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>
